import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { tiposProveedoresAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../Clientes.css';

const TipoProveedorForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    activo: true,
    gasto_fijo: false,
  });

  const loadTipo = useCallback(async () => {
    try {
      const response = await tiposProveedoresAPI.getById(id);
      if (response.success) {
        setFormData({
          ...response.data,
          gasto_fijo: !!response.data.gasto_fijo,
        });
      }
    } catch (error) {
      toast.error('Error al cargar tipo');
      navigate('/tipos-proveedores');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      loadTipo();
    }
  }, [id, loadTipo]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;
      if (id) {
        response = await tiposProveedoresAPI.update(id, formData);
      } else {
        response = await tiposProveedoresAPI.create(formData);
      }

      if (response.success) {
        toast.success(id ? 'Tipo actualizado exitosamente' : 'Tipo creado exitosamente');
        navigate('/tipos-proveedores');
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar tipo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cliente-form">
      <h1>{id ? 'Editar Tipo de Proveedor' : 'Nuevo Tipo de Proveedor'}</h1>

      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-row">
          <div className="form-group">
            <label>Nombre *</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Descripción</label>
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            rows="3"
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px', width: '100%' }}
          />
        </div>

        <div className="form-group">
          <label className="form-toggle-wrap">
            <span className="toggle-switch-box">
              <input
                type="checkbox"
                name="gasto_fijo"
                checked={!!formData.gasto_fijo}
                onChange={handleChange}
              />
              <span className="form-toggle-switch" />
            </span>
            <span className="form-toggle-label">Gasto fijo mensual (proyección de fondos)</span>
          </label>
        </div>

        <div className="form-group">
          <label className="form-toggle-wrap">
            <span className="toggle-switch-box">
              <input
                type="checkbox"
                name="activo"
                checked={formData.activo}
                onChange={handleChange}
              />
              <span className="form-toggle-switch" />
            </span>
            <span className="form-toggle-label">{formData.activo ? 'Desactivar' : 'Activar'}</span>
          </label>
        </div>

        <div className="form-actions">
          <button type="button" onClick={() => navigate('/tipos-proveedores')} className="btn-secondary">
            Cancelar
          </button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TipoProveedorForm;
